export const en = {
  "claimListingPage": {
    "title": "Claim This Listing",
    "descriptionPrefix": "You've been invited to claim this pre-filled listing. ",
    "descriptionLoggedIn": " Click \"Claim & Publish\" to make it yours. You can edit the listing after publishing.",
    "descriptionLoggedOut": " Sign up or log in to claim it. You can edit the listing after publishing.",
    "intendedFor": "This listing was prepared for:",
    "loggedInAs": "You're logged in as {{email}}. You can still claim this listing.",
    "existingListingInBuilding": "You already have a listing record for this building, so this invite can't be claimed.",
    "loading": "Loading listing...",
    "notAvailable": {
      "title": "Listing Not Available",
      "invalidToken": "This claim link is invalid or has expired.",
      "alreadyClaimed": "This listing has already been claimed.",
      "errorDefault": "Failed to load claim page",
      "homeButton": "Go to Homepage"
    },
    "success": {
      "title": "Listing Claimed Successfully!",
      "published": "Your listing has been published and is now visible to other users.",
      "redirecting": "Redirecting to your listing..."
    },
    "action": {
      "readyTitle": "Ready to claim this listing?",
      "readyText": "By claiming this listing, it will be published under your account and become visible to other users.",
      "claimButton": "Claim & Publish",
      "claiming": "Claiming..."
    },
    "auth": {
      "ctaTitle": "Sign up or log in to claim this listing",
      "ctaText": "Create a free account to claim this listing and start connecting with potential buyers or sellers.",
      "button": "Sign Up / Log In",
      "alreadyHaveAccount": "Already have an account? Log in to claim this listing."
    },
    "expiry": {
      "warning": "This claim link expires on {{date}}"
    },
    "details": {
      "title": "Property Details",
      "description": "Description:",
      "size": "Size:",
      "rooms": "Rooms:",
      "floor": "Floor:",
      "condition": "Condition:",
      "m2": "m²"
    },
    "condition": {
      "recently_renovated": "Recently Renovated",
      "good_condition": "Good",
      "needs_renovation": "Needs renovation"
    },
    "amenities": {
      "elevator": "Elevator",
      "balcony": "Balcony"
    },
    "photos": {
      "title": "Property Photos"
    },
    "type": {
      "forSale": "For Sale",
      "lookingToBuy": "Looking to Buy"
    }
  },
  "landingPage": {
    "jaakko": {
      "title": "Jaakko"
    },
    "startSearch": "Search listings",
    "startSearchDesktop": "Search listings",
    "latestListings": "Latest listings",
    "map": {
      "title": "Property map"
    },
    "couldBuyOrCouldSellModal": {
      "sell": {
        "title": "Could sell",
        "description": "Enter the property address to connect with potential buyers. It's free, non-binding, and you can cancel at any time."
      },
      "buy": {
        "title": "Could buy",
        "description": "Enter the property address to connect with sellers. It's free, non-binding, and you can cancel at any time."
      },
      "submitError": "An error occurred while submitting. Please try again.",
      "addressMismatch": "The address of the building doesn't match the entered address. Please verify your address or select a different building. Clicking on the edge of the building might sometimes result in the neighboring building address."
    }
  },
  "newLandingPage": {
    "header": {
      "languageEnglish": "In English",
      "languageFinnish": "Suomeksi",
      "switchLanguageToEnglish": "Switch language to English",
      "switchLanguageToFinnish": "Vaihda kieli suomeksi",
      "signIn": "Sign in",
      "openMenuAria": "Open menu",
      "openProfileAria": "Open profile"
    },
    "menu": {
      "title": "More",
      "closeAria": "Close menu"
    },
    "profile": {
      "title": "Me",
      "backAria": "Back",
      "closeAria": "Close"
    },
    "nav": {
      "label": "Main navigation",
      "explore": "Explore",
      "activity": "Activity",
      "messages": "Messages",
      "tools": "Tools",
      "unread": "{{label}}, {{count}} unread"
    },
    "activityToast": {
      "found_one": "We found <1>{{count}} home</1> that could interest you.",
      "found_other": "We found <1>{{count}} homes</1> that could interest you.",
      "empty": "We will show here homes that interest you."
    },
    "tools": {
      "title": "Jaakko tools",
      "closeAria": "Close tools",
      "estimate": {
        "title": "Price estimate",
        "subtitle": "Create an indicative AI price estimate for your home based on market data.",
        "tag": "3 free estimates per day"
      },
      "style": {
        "title": "Photo clean-up",
        "subtitle": "Create more attractive listing photos in seconds when posting a listing.",
        "tag": "60 cleaned-up photos for free"
      },
      "boost": {
        "title": "Visibility boost",
        "subtitle": "Promote your listing on social media to reach more potential buyers.",
        "tag": "€49.90 / 2 weeks"
      }
    },
    "toolFlows": {
      "loading": "Loading your listings…",
      "error": "Couldn't load your listings.",
      "retry": "Try again",
      "empty": {
        "text": "You don't have a sell listing yet. Create one first — it only takes a minute.",
        "cta": "Add my place"
      },
      "pickerHint": "Choose a listing",
      "boostSuccess": "Request sent! We'll email you within 12 hours with details and a payment link.",
      "done": "Done",
      "start": "Start estimation",
      "starting": "Starting…",
      "startError": "Couldn't start the estimation. Please try again.",
      "dailyLimit": "Daily estimation limit reached. Try again tomorrow.",
      "rooms": "{{rooms}} rooms",
      "chooseNewAddress": "Estimate a new address",
      "chooseFromListings": "Choose from your listings",
      "estimateCtaGet": "Estimate price",
      "addDetailsHint": "Get a more accurate price estimate.",
      "formTitle": "Nice, ready to estimate?",
      "sellPromptTitle": "Estimation started. Would you also like to list it for sale?",
      "sellPromptYes": "Yes, list for sale",
      "sellPromptNo": "Maybe later"
    },
    "activity": {
      "title": "Activity",
      "sections": {
        "myPlaces": "My places",
        "buyingInterests": "My buy interests",
        "following": "Following"
      },
      "newBuyers": "{{count}} new buyers",
      "newListings": "{{count}} new listings",
      "newLikes": "{{count}} new likes",
      "buyers": "{{count}} buyers",
      "buyersInBuilding_one": "{{count}} buyer in this building",
      "buyersInBuilding_other": "{{count}} buyers in this building",
      "listings_one": "{{count}} listing",
      "listings_other": "{{count}} listings",
      "confirmedMatches_one": "{{count}} match",
      "confirmedMatches_other": "{{count}} matches",
      "possibleMatches_one": "{{count}} possible match",
      "possibleMatches_other": "{{count}} possible matches",
      "floorUnconfirmed": "Floor preference unconfirmed",
      "loadMore": "Show more listings",
      "retry": "Try again",
      "likes_one": "{{count}} like",
      "likes_other": "{{count}} likes",
      "followingUnnamed": "Followed building",
      "promo": {
        "myPlaces": {
          "text": "Add your first place to see who could buy it."
        },
        "buyingInterests": {
          "text": "Tell us what you're after and get matched with new listings."
        },
        "following": {
          "text": "Tap Get alerts on a building to follow it and track its activity.",
          "cta": "Explore the map"
        },
        "learnMore": "Learn more"
      },
      "detail": {
        "back": "Back to activity",
        "boost": {
          "title": "Boost your visibility",
          "bodySell": "To reach even more potential buyers, you can boost your listing with targeted ads on social media.",
          "bodyBuy": "To reach even more potential sellers, you can boost your listing with targeted ads on social media.",
          "cta": "Boost your listing",
          "dismiss": "Dismiss"
        },
        "newListings": "New listings",
        "newBuyers": "New buyers",
        "otherListings": "Other listings",
        "otherBuyers": "Other buyers",
        "possibleTitle": "Possible matches",
        "possibleDescription": "These homes may suit your preferences. Some details are still missing - you can ask the seller directly for more information.",
        "empty": "Nothing to show here yet."
      },
      "fab": {
        "openAria": "Create new listing or buy interest",
        "closeAria": "Close create menu",
        "couldSell": "Add your home",
        "interestInBuying": "Let sellers know"
      }
    },
    "hero": {
      "homes": "Homes",
      "and": "and",
      "buyers": "buyers",
      "tail": " beyond public listings.",
      "subheadline": "Talk directly to sellers and buyers – no middlemen, no commission.",
      "startExploring": "Start exploring"
    },
    "mapOnboarding": {
      "farTitle": "Open any building",
      "farBody": "Zoom in, then click any building to explore it—even if nothing is for sale.",
      "farBodyTouch": "Zoom in, then tap any building to explore it—even if nothing is for sale.",
      "nearTitle": "Click any building",
      "nearTitleTouch": "Tap any building",
      "nearBody": "Explore it—even if nobody is buying or selling there yet.",
      "zoomIn": "Zoom in",
      "gotIt": "Got it",
      "dismiss": "Close hint"
    },
    "explore": {
      "actions": {
        "sellAdvice": "No commitment or commission",
        "buyAdvice": "Looking for a new home?"
      },
      "search": "Search",
      "filter": "Filters",
      "searchAria": "Search",
      "filterAria": "Filters",
      "closeSearchAria": "Close search",
      "clearSearchAria": "Clear search",
      "geolocateAria": "Show my location",
      "closeListAria": "Close listings",
      "testHomeValue": "Test your home’s value",
      "buyingInterest": "Let sellers know",
      "buyingInterestHint": "Looking for a new home?",
      "areaInterest": {
        "stage1": "Some buying interest in this area! Zoom in on a building to view activity.",
        "stage2": "Growing buying interest in this area! Zoom in on a building to view activity.",
        "stage3": "Strong buying interest in this area! Zoom in on a building to view activity.",
        "stage4": "Very strong buying interest in this area! Zoom in on a building to view activity.",
        "stage5": "Exceptional buying interest in this area! Zoom in on a building to view activity."
      },
      "sellersCount_one": "{{count}} seller",
      "sellersCount_other": "{{count}} sellers",
      "buyersCount_one": "{{count}} buyer",
      "buyersCount_other": "{{count}} buyers",
      "sellersBuyersAria": "Show sellers and buyers in view",
      "collapsePanelAria": "Collapse the listings panel",
      "expandPanelAria": "Expand the listings panel",
      "testHomeValueSubtitle": "with a free Jaakko Estimate",
      "zoomInAria": "Zoom in",
      "zoomOutAria": "Zoom out",
      "zoomInToSeeAll": "Zoom in to see all listings",
      "areaFallback": "This area",
      "suggestedDistricts": "Suggested districts",
      "showcaseCaption": "See how Jaakko works in practice",
      "showcaseCity": "Helsinki ({{total}} listings)",
      "districtsNearYou": "Districts near you",
      "usingYourLocation": "Using your location",
      "youAreHere": "You’re here",
      "kmAway": "{{km}} km away",
      "loadingDistricts": "Finding districts…",
      "locationDenied": "Location is blocked for this site. Allow it in your browser’s site settings, then tap again.",
      "locationUnavailable": "We couldn’t get your location. Check that location services are on, then tap again.",
      "locationInsecure": "Location only works over a secure (https) connection.",
      "continents": {
        "europe": "Europe",
        "northAmerica": "North America",
        "southAmerica": "South America",
        "asia": "Asia",
        "oceania": "Oceania",
        "world": "World"
      }
    },
    "addMyPlace": {
      "title": "Add your home",
      "backAria": "Back",
      "closeAria": "Close",
      "address": {
        "question": "What’s your place’s address?",
        "label": "Address",
        "placeholder": "Enter address",
        "useCurrentLocation": "Use current location",
        "locating": "Finding your location…",
        "locationDenied": "Location access was denied. Enter your address instead.",
        "locationUnavailable": "We couldn’t find your location. Enter your address instead.",
        "houseNumberRequired": "Please include a house number in the address.",
        "addressNotFound": "We couldn’t find this address. Check the house number.",
        "noBuildingHere": "Oops – we can’t find a building at this address yet.",
        "checkingBuilding": "Checking address…",
        "loading": "Loading…"
      },
      "building": {
        "calloutTitle": "My place",
        "notYourBuilding": "Not your building? Select the right one by clicking on the map.",
        "selectBuildingOnMap": "Select the right building by clicking on the map.",
        "pickNoAddress": "We couldn’t find an address for this building. Click another building.",
        "buildingLabel": "Building",
        "typeApartment": "Apartment / flat",
        "typeRowHouse": "Row house",
        "typeDuplex": "Duplex",
        "typeDetached": "House (detached)",
        "typeOther": "Other",
        "next": "Next"
      },
      "size": {
        "question": "How big is the place (in m²)?",
        "label": "Size (m²)",
        "placeholder": "Enter m²"
      },
      "rooms": {
        "question": "How many rooms are there?",
        "label": "Rooms",
        "more": "More"
      },
      "publish": {
        "title": "Nice, ready to publish?",
        "roomsValue": "{{rooms}} rms",
        "estimatingPrice": "Automatic price estimate",
        "estimateInfoAria": "About this estimate",
        "estimateInfo": "Jaakko estimates the price using AI and market data. This is not an official valuation report, but an indicative conversation starter – you can always set your own price.",
        "addMoreDetails": "Add details and photos",
        "addMoreDetailsHint": "Get a more accurate price estimate and make your listing stand out to buyers.",
        "closeDetails": "Close details",
        "estimateReadyStrong": "You’ll receive a message about the price estimate within 15 min of publishing.",
        "estimateReadyRest": "You can edit the price anytime.",
        "publish": "Publish to map",
        "publishing": "Please wait"
      },
      "details": {
        "listingStrength": "Listing strength",
        "basic": "Basic",
        "strengthHint": "Add photos and your place will spark more interest for others when browsing homes.",
        "addPhotos": "Add photos",
        "listingDetails": "Listing details",
        "addPhoto": "Add photo",
        "openPhoto": "Open photo {{number}}",
        "photoAlt": "Listing photo {{number}}",
        "photoUploading": "Uploading...",
        "photoEnhancing": "Enhancing...",
        "photoTipStrong": "Don’t have any nice photos?",
        "photoTipRest": "Add your photos as they are. Jaakko will clean them up and polish them in seconds. You can always use the originals too.",
        "enhancedPhotoTipStrong": "See the enhanced photos!",
        "enhancedPhotoTipRest": "Open a photo and toggle the enhanced version to see and use it instead.",
        "addDescription": "Add description",
        "address": "Address",
        "type": "Type",
        "price": "Price (€)",
        "pricePlaceholder": "Enter price (min. 1 000 €)",
        "priceTipStrong": "Do you already have a price?",
        "priceTipRest": "Add your own price above, or change it anytime.",
        "priceEstimateTipStrong": "Set your price or let Jaakko estimate",
        "priceEstimateTipRest": "If left empty, Jaakko calculates an indicative estimate using AI and market data. You can edit it anytime.",
        "priceTooLow": "The minimum price is 1 000 €. Delete the price and Jaakko will estimate it for you.",
        "estimatingTipStrong": "Jaakko is estimating the price...",
        "estimatingTipRest": "The estimate will be ready in about 15 minutes. You’ll get a message when it’s done. You can still enter your own price.",
        "addFloor": "Add floor number",
        "addRenovation": "Add renovation status",
        "hasElevator": "Has elevator",
        "hasBalcony": "Has balcony / terrace",
        "descriptionLabel": "Description",
        "descriptionPlaceholder": "Describe what makes your home special...",
        "floorLabel": "Floor number",
        "floorPlaceholder": "e.g. 4",
        "renovationLabel": "Renovation status",
        "renovationSelect": "Select renovation status",
        "renovationRecentlyRenovated": "Recently renovated",
        "renovationGoodCondition": "Good condition",
        "renovationNeedsRenovation": "Needs renovation",
        "elevatorLabel": "Elevator",
        "balconyLabel": "Balcony / terrace",
        "optionYes": "Yes",
        "optionNo": "No"
      },
      "login": {
        "title": "Login or sign up",
        "google": "Continue with Google",
        "facebook": "Continue with Facebook",
        "orEmail": "or continue with email",
        "emailPlaceholder": "Email",
        "continue": "Continue",
        "termsPrefix": "By signing up, you create a Jaakko account and agree to follow our",
        "termsService": "terms of service",
        "termsMiddle": ", and acknowledge that you have read and accept Jaakkocom Oy’s",
        "termsPrivacy": "privacy policy",
        "termsSuffix": "."
      },
      "result": {
        "newBadge": "New",
        "buyers_one": "{{count}} buyer",
        "buyers_other": "{{count}} buyers",
        "followers_one": "{{count}} follower",
        "followers_other": "{{count}} followers",
        "likeAria": "Save to favourites",
        "closeAria": "Close"
      },
      "share": {
        "title": "Your home is live!",
        "subtitle": "Matching buyers will be notified about your home. You’ll get a message when a buyer reaches out – you can also suggest your home to buyers yourself, or share it to get extra visibility.",
        "matchSubtitle": "Buyers are already waiting. See them under Activity and suggest your home to them, or share your listing for even more visibility.",
        "edit": "Edit",
        "shareButton": "Share now",
        "boostButton": "Boost with ads – 49,90 €",
        "boostSubtitle": "Get more buyers with targeted ads.",
        "skipButton": "Maybe later"
      }
    },
    "couldBuy": {
      "boostPromo": {
        "title": "Speed up finding your dream home",
        "body": "We’ll promote your buying interest to local residents on social media.",
        "cta": "Boost visibility"
      },
      "title": "Create a buy interest",
      "editTitle": "Edit buy interest",
      "titlePublished": "Buying interest published",
      "titleUpdated": "Buying interest updated",
      "tooManyAreas": "You can choose up to 50 areas. Remove some and try again.",
      "location": {
        "question": "Where could you buy?",
        "hint": "Interested near {{building}}? Add the areas you'd consider.",
        "placeholder": "Search a neighbourhood",
        "searching": "Searching…",
        "clearAria": "Clear",
        "removeChipAria": "Remove area",
        "radiusLabel": "Or a radius around this home",
        "radiusValue": "{{km}} km",
        "radiusOff": "Off",
        "selectAreaError": "Please add at least one area or set a radius."
      },
      "criteria": {
        "question": "What are you looking for?",
        "sizeLabel": "Minimum size (m²)",
        "roomsLabel": "Minimum rooms",
        "priceMinLabel": "Min price (€)",
        "priceMaxLabel": "Max price (€)",
        "anyPlaceholder": "Any",
        "priceMinHandleAria": "Minimum price",
        "priceMaxHandleAria": "Maximum price"
      },
      "success": {
        "title": "You're all set!",
        "subtitle": "We'll let you know when a matching home appears in your areas.",
        "areasLabel": "Your areas",
        "radiusArea": "{{km}} km radius",
        "notifyEmail": "Send me emails",
        "notifySms": "Send me SMS",
        "share": "Share my interest",
        "done": "Done",
        "viewMatches": "View matching listings",
        "matchedSellersOne": "One seller in this building already matches what you are looking for. Open their listing to start a chat.",
        "matchedSellersOther": "{{count}} sellers in this building already match what you are looking for. Open a listing to start a chat.",
        "headline": "Superb! Your buying interest is now active.",
        "editHeadline": "Your buying interest is updated.",
        "subtitlePrefix": "Based on your interest we will start showing you relevant homes under",
        "editSubtitlePrefix": "We will keep showing you relevant homes under",
        "subtitleActivity": "Activity",
        "notifyHeading": "Notify me about fresh listings",
        "smsNeedsPhone": "To get SMS, add and verify a phone number in your profile settings.",
        "circleArea": "500 m radius",
        "anyCriteria": "Any criteria",
        "roomsUnit": "rooms"
      },
      "share": {
        "title": "Spread the word",
        "subtitle": "Share so more sellers in your areas see your interest.",
        "shareButton": "Share now",
        "skipButton": "Maybe later"
      },
      "main": {
        "locationTitle": "Location",
        "chooseLocation": "Choose a location",
        "selectLocationError": "Select a building or area to post your interest.",
        "expandArea": "Expand your interest area",
        "within500m": "within 500m",
        "chooseOnMap": "Choose areas",
        "descriptionLabel": "Description",
        "anyDescription": "No description",
        "descriptionPlaceholder": "Describe the kind of home you’re looking for...",
        "sizeLabel": "Size",
        "anySize": "Any size",
        "roomsLabel": "Rooms",
        "anyRooms": "Any amount",
        "roomsUnit": "rooms",
        "anyTab": "Any",
        "roomsFlexible": "Flexible with +/- 1 room",
        "priceLabel": "Price",
        "anyPrice": "Any price",
        "minPlaceholder": "Min",
        "maxPlaceholder": "Max",
        "includeUnpriced": "Include unpriced listings",
        "floorLabel": "Floor",
        "anyFloor": "Any level",
        "floorHighest": "Highest floor",
        "floorMid": "Middle floors",
        "floorLowest": "Lowest floor",
        "renovationLabel": "Renovation status",
        "anyRenovation": "Any condition",
        "renovationRecent": "Recently renovated",
        "renovationGood": "Good condition",
        "renovationNeeds": "Needs renovation",
        "amenitiesLabel": "Amenities",
        "anyAmenities": "Add amenities",
        "amenityElevator": "Elevator",
        "amenityBalcony": "Balcony / Terrace",
        "postButton": "Post your interest",
        "saveButton": "Save changes"
      },
      "mapPicker": {
        "title": "Location",
        "subtitle": "Select a building or district.",
        "searchPlaceholder": "Search",
        "recenterAria": "Center on this home",
        "myLocationAria": "Show my location",
        "zoomAria": "Zoom",
        "zoomInAria": "Zoom in",
        "zoomOutAria": "Zoom out",
        "unselectBuildingAria": "Unselect this building",
        "removeAreaAria": "Remove {{name}}",
        "loadingAreas": "Loading areas…",
        "areasUnavailable": "Areas couldn't be fully loaded. Move the map or try again later.",
        "done": "Done"
      },
      "myAreas": {
        "title": "My areas",
        "empty": "No saved buy areas yet.",
        "loadError": "Couldn't load your areas.",
        "retry": "Retry",
        "circleLabel": "500 m radius",
        "circleAround": "{{address}} ± 500 m",
        "noAreas": "No areas selected",
        "anyCriteria": "Any criteria",
        "roomsValue": "{{count}}+ rooms",
        "notifyEmail": "Email",
        "notifySms": "SMS",
        "notifyNone": "No notifications",
        "editButton": "Edit",
        "deleteButton": "Delete",
        "confirmDelete": "Confirm delete"
      }
    }
  },
  "common": {
    "showMore": "Show more",
    "showLess": "Show less",
    "readMore": "Read more...",
    "readLess": "Read less",
    "back": "Back",
    "address": "Address",
    "close": "Close",
    "findingLocation": "Finding your location...",
    "cancel": "Cancel",
    "optional": "optional",
    "yes": "Yes",
    "no": "No",
    "retry": "Retry",
    "error": "An error occurred. Please try again.",
    "loading": "Loading...",
    "next": "Next",
    "previous": "Previous",
    "edit": "Edit",
    "remove": "Remove",
    "forSale": "Could sell"
  },
  "propertyMap": {
    "title": "Property map",
    "subtitle": "Buy or sell homes with ease. Connect directly and discuss in private.",
    "explore": "Open map",
    "exploreHintSmallScreen": "Click any building",
    "exploreHintLargeScreen": "Click any building on the map",
    "approximateLocationHint": "Your browser shared an approximate location, so the map may be less exact.",
    "approximateLocationHintIosChrome": "Chrome shared an approximate location. Enable Precise Location for Chrome on your iPhone for a more exact map position."
  },
  "feed": {
    "title": "Latest events",
    "button": {
      "showFeed": "Feed",
      "hideFeed": "Hide"
    },
    "likeBuildingEvent": {
      "text": "User liked this building"
    },
    "offMarketWillingnessEvent": {
      "sell": {
        "text": "Owner willing to sell"
      },
      "buy": {
        "text": "Interested buyer"
      }
    },
    "sellerBuyerOverlapEvent": {
      "text": "Sellers and buyers in the same building!"
    }
  },
  "map": {
    "showMap": "Show property map",
    "showFeed": "Show property feed"
  },
  "mainMenu": {
    "whatIsJaakko": "What is Jaakko.com?",
    "contact": "Contact",
    "termsConditions": "Terms & Conditions",
    "privacyPolicy": "Privacy Policy",
    "cookies": "Cookies",
    "cookieSettings": "Cookie settings",
    "language": "Language",
    "feedback": "Send Feedback",
    "copyright": "© 2026 Jaakkocom Oy"
  },
  "building": {
    "controls": {
      "follow": "Follow",
      "share": "Share",
      "like": "Like",
      "more": "More"
    },
    "view": {
      "buyer": "buyer",
      "buyers": "buyers",
      "likes": "likes",
      "views": "views",
      "follower": "follower",
      "followers": "followers",
      "learnMore": "Learn more",
      "emptyPrompt": "Be the first to sell or show you are interested in buying here.",
      "buyersHint_one": "There is <b>{{count}}</b> buyer for a home here. Be the first to sell.",
      "buyersHint_other": "There are <b>{{count}}</b> buyers for a home here. Be the first to sell.",
      "sellersHint_one": "There is <b>{{count}}</b> seller in this building. Be the first to buy.",
      "sellersHint_other": "There are <b>{{count}}</b> sellers in this building. Be the first to buy.",
      "sellers": "For sale in this building",
      "buyersTitle": "Interested buyers",
      "buildingInfo": "Building info",
      "buyerBadge": "Buyer",
      "addImage": "Add image",
      "lookingFor": "Looking for",
      "suggest": "Suggest",
      "share": "Share",
      "sellHere": "Sell here",
      "buyHere": "Buy here",
      "youAreSellingHere": "You are selling here",
      "youHaveBuyingInterestHere": "You have buying interest here",
      "viewMap": "View map",
      "getAlerts": "Get alerts",
      "alertsError": "Could not update alerts. Please try again.",
      "likeError": "Could not update your like. Please try again.",
      "alertsAddressPending": "Waiting for this building’s address.",
      "alertsNoStreet": "Alerts need a street address.",
      "noStreetAddress": "No street address",
      "sellersCtaTitle": "Couldn’t find what you needed?",
      "sellersCtaBody": "Let others know what you are looking for.",
      "addBuyingInterest": "Add buying interest",
      "buyersCtaBody": "Do you own a home in this building? There is a good chance people are interested in buying it.",
      "iCouldSell": "I could sell",
      "previewNoMatchingListings": "No listings in this building match your filters.",
      "previewEmptyInterest": "Be the first to show interest in selling or buying in this building.",
      "cornerBuilding": "Corner building, also on {{street}}",
      "frontagesMore": "+{{n}} more",
      "frontagesMoreAria": "Show {{n}} more: {{streets}}",
      "frontagesLess": "Show less"
    },
    "generalInfo": {
      "property": "Property",
      "redemptionClause": {
        "title": "Redemption clause",
        "yes": "Yes",
        "no": "No"
      },
      "plotOwnership": {
        "title": "Plot",
        "owned": "Own",
        "rented": "Rented"
      }
    },
    "apartments": {
      "title": "Flats",
      "units": {
        "count": "{{count}} units",
        "countEmpty": "- units"
      },
      "roomCount": "{{count}} room",
      "roomCount_one": "{{count}} room",
      "roomCount_other": "{{count}} rooms",
      "fourPlusRooms": "4+ rooms"
    },
    "offMarket": {
      "title": "Listings",
      "emptyPlaceholder": {
        "firstLine": "No interests yet.",
        "secondLine": "Could you consider selling or buying here? Tap the button. ☝️"
      },
      "couldSell": "Could sell",
      "couldBuy": "Could buy",
      "shareTitle": {
        "couldSell": "Owner willing to sell",
        "couldBuy": "Interested buyer"
      },
      "sharedEvent": {
        "sellTitle": "Selling interest",
        "buyTitle": "Buying interest",
        "description": "This listing was shared with you."
      },
      "count_one": "{{count}} user",
      "count_other": "{{count}} users",
      "infoButton": "What are these",
      "infoModalText": "Could you sell or would you like to buy here? Express your interest with just one click - easier than ever! We connect you with the other party anonymously and with no commitments. Conversations open directly in the Messages section, and your email address is only shared if you choose to send a message or reply to an inquiry. You can remove your interest at any time. <1>Read more...</1>",
      "toast": {
        "couldSellNoBuyers": "Great! When a potential buyer is found, you will receive an email.",
        "couldSellAndBuyers": "Also buyers are interested, you can now discuss directly.",
        "couldBuyNoSellers": "Great! When a potential seller is found, you will receive an email.",
        "couldBuyAndSellers": "Also sellers are interested, you can now discuss directly.",
        "userSellerAndBuyer": "Selling and buying in the same house is not yet supported. We're working on adding this feature soon.",
        "couldBuyLimitReached": "Buy-interest limit reached. <1>Verify your identity</1> for unlimited proposals."
      },
      "modal": {
        "sell": {
          "title": "Could sell",
          "description": "Express your interest to connect with potential buyers. It's free, non-binding, and you can cancel at any time."
        },
        "buy": {
          "title": "Could buy",
          "description": "Express your interest to connect with sellers. It's free, non-binding, and you can cancel at any time."
        },
        "edit": {
          "menuTitle": "Edit",
          "title": "Edit property details",
          "buyDescription": "Update the details of your buying interest.",
          "sellDescription": "Update the details of your selling interest."
        },
        "cancel": "Cancel",
        "delete": "Remove",
        "deleteConfirmTitle": "Remove listing",
        "deleteConfirmText": "Are you sure you want to remove this listing?",
        "remove": {
          "menuTitle": "Remove"
        },
        "removeSell": {
          "title": "How did your selling journey go?",
          "subtitle": "Help us improve by letting us know why you're removing your listing.",
          "reasons": {
            "SOLD_VIA_JAAKKO": "I sold through Jaakko",
            "SOLD_ELSEWHERE": "I sold elsewhere",
            "NO_LONGER_SELLING": "I'm no longer selling",
            "JUST_TESTING_INTEREST": "I just wanted to test interest",
            "NOT_ENOUGH_CONTACTS": "I didn't get enough contacts / suitable buyers",
            "PREFER_NOT_TO_SAY": "I prefer not to say",
            "OTHER": "Other, what?"
          },
          "otherPlaceholder": "Tell us more...",
          "confirmButton": "Remove listing",
          "cancelButton": "Cancel",
          "closeLabel": "Close"
        },
        "confirm": "Confirm",
        "update": "Update",
        "detailsOptional": "Apartment Details (Optional)",
        "description": "Description",
        "buyingInterestDescriptionPlaceholder": "Add details about the apartments you're interested in...",
        "sellingInterestDescriptionPlaceholder": "Add details about the apartment you could sell...",
        "additionalDetails": "Additional details (Optional)",
        "size": "Size (m²)",
        "sizePlaceholder": "e.g. 65",
        "sizeClass": "Preferred size (m²)",
        "roomsLabel": "Number of rooms",
        "selectRooms": "Select rooms",
        "buildingType": "Building type",
        "selectBuildingType": "Select building type",
        "apartmentBuilding": "Apartment building",
        "detachedHouse": "Detached house",
        "other": "Other",
        "terracedHouse": "Terraced house",
        "duplex": "Duplex",
        "rooms": "Room",
        "rooms_one": "Room",
        "rooms_other": "Rooms",
        "floor": "Floor",
        "floorPlaceholder": "e.g. 3",
        "renovation": "Renovation status",
        "selectRenovation": "Select status",
        "recentlyRenovated": "Recently renovated",
        "goodCondition": "Good condition",
        "needsRenovation": "Needs renovation",
        "hasElevator": "Has elevator",
        "hasBalcony": "Has balcony/terrace",
        "address": "Address",
        "addressPlaceholder": "Enter property address",
        "selectBuildingOnMap": "Click the correct building on the map to continue",
        "loading": "Loading...",
        "checkingBuilding": "Checking for building...",
        "buildingFound": "Building detected at this address",
        "sellInterestNoBuildingFound": "Building not found, please use the Property Map function to sell.",
        "buyInterestNoBuildingFound": "Building not found, please use the Property Map function to buy.",
        "incompleteAddress": "Select the full address from the dropdown, including the building number and city, e.g., Keskuskatu 1, Helsinki. You can also select the building from the property map.",
        "addPropertyImages": "Add property images (up to 30)",
        "dragImagesHere": "Drag files here or click to browse",
        "propertyImage": "Property image",
        "removeImage": "Remove image",
        "uploadFailed": "Upload failed",
        "unsupportedImage": "File type not supported.",
        "coverPhoto": "Cover",
        "dragToReorder": "Drag to reorder",
        "reorderHint": "Drag images from the icon to reorder them",
        "reorderHintMobile": "Press and hold to reorder images",
        "selectImagesToRemove": "Pick images to remove",
        "selectImage": "Select image",
        "removeSelected": "Remove {{count}} selected",
        "removeSelected_one": "Remove 1 selected",
        "removeSelected_other": "Remove {{count}} selected",
        "selectImages": "Select images",
        "imageLimitExceeded": "Maximum {{max}} images allowed",
        "fileTooLarge": "Some files exceed the maximum size of {{max}}. Please use smaller images.",
        "aiEnhance": "Jaakko Enhance",
        "enhancementsRemaining": "{{count}} enhancements remaining",
        "dailyLimitReached": "Daily enhancement limit reached",
        "creditsRemaining": "{{count}} photos remaining",
        "buyCredits": "Buy credits",
        "creditsAvailable": "{{count}} photos remaining",
        "noCreditsAvailable": "No photos remaining",
        "creditsPricing": "Photo styling now 4,90 €\n50% off!",
        "purchaseError": "Could not start purchase. Please try again.",
        "processing": "Processing...",
        "showOriginal": "Use original image",
        "showEnhanced": "Use enhanced image",
        "regenerate": "Regenerate",
        "regenerating": "Regenerating...",
        "regenerateCreditInfo": "Uses 1 enhancement credit · {{count}} left",
        "regenerateNoCreditInfo": "No credits left - regenerate to buy more",
        "enhanceThisImage": "Enhance this image",
        "enhancing": "Enhancing...",
        "noEnhancementCreditsLeft": "No enhancement credits left",
        "buyCreditsToEnhance": "Buy credits to enhance this image.",
        "enhanced": "Enhanced",
        "original": "Original",
        "addressMismatch": "The selected building doesn't match the entered address. Please verify your address or select a different building.",
        "singleView": "Single View",
        "compareView": "Compare",
        "aiEnhanced": "AI Enhanced",
        "enhancementFailed": "Enhancement unavailable",
        "or": "Or use original photos",
        "aiEnhancementTitle": "Sell faster with stunning photos",
        "aiEnhancementDescription": "Professional photos can <1>3x your selling chances</1>. Let Jaakko clean and style your home photos in seconds: cleaner home, more stylish interior, brighter lighting.",
        "aiEnhancementDescriptionReadMoreLink": "Read more and see the difference before and after.",
        "aiEnhancementNormalPrice": "\nNormally 9.90 € (60 photos)",
        "uploadAndEnhance": "Select photos",
        "pickPhotos": "Select photos",
        "takePhotos": "Take photo",
        "buyCreditsButton": "Style your photos",
        "pleaseSelectAddress": "Please select an address",
        "sellInterestRegistered": "Your selling interest has been registered successfully!",
        "buyInterestRegistered": "Your buying interest has been registered successfully!",
        "submitError": "An error occurred while submitting. Please try again.",
        "sellListingsLimitReached": "You have reached the limit for new sell listings.",
        "automaticEstimateDailyLimit": "You've used all of today's automatic price estimates.",
        "alreadySellingInBuilding": "You already have a listing in this building. Edit that listing, or remove it and add it again.",
        "sizeMustBeGreaterThanZero": "Invalid size.",
        "clickBuildingInstruction": "Click the correct building at your address on the map to continue.",
        "buildingSelected": "Building selected",
        "receivedAddress": "Building address:",
        "askingPrice": "Asking price (€)",
        "optional": "(optional)",
        "pricePlaceholder": "e.g. 250000",
        "startPriceEstimation": "Jaakko's free property value estimate",
        "startPriceEstimationBuildingPage": "Free property value estimate",
        "updatePriceEstimation": "Update property value estimate",
        "estimatingPrice": "Estimating property value...",
        "emailWhenReady": "You can find your price estimation under “Profile” when the report is ready. Come back in about 20 minutes. You will also receive an email when the report is ready.",
        "selectBuildingFirst": "Finish adding the address first.",
        "estimationReady": "Price estimation ready",
        "viewFullReport": "View report",
        "estimationFailed": "Price estimation failed",
        "priceEstimation": {
          "notAvailable": "Not available"
        },
        "firstPhotosFreeOfCharge": "60 styled photos for free! 🎉",
        "before": "Before",
        "after": "After",
        "estimationError": {
          "daily_limit_reached": "You have used your price estimations for this day. You can get new free price estimations tomorrow. We are developing the service. In the future you can buy more price estimations per day."
        },
        "preEstimationTitle": "Let's estimate your property value",
        "preEstimationSubtitle": "Please provide at least the size, number of rooms and building type for an accurate estimate. The more details you add, the better!",
        "preEstimationTip": "Tip: Adding floor, renovation state, balcony, elevator or a description will improve accuracy",
        "preEstimationBack": "Back",
        "startEstimation": "Start estimate",
        "estimationTime": "Price estimation typically takes 15-20 minutes. You have three free estimations per day.",
      },
      "template": {
        "loading": "Loading template...",
        "usingTemplate": "Using saved template",
        "clear": "Clear template",
        "update": "Update template",
        "save": "Save as template",
        "updateTemplate": "Update template",
        "saveAsTemplate": "Save as template",
        "moreInfo": "More info",
        "tooltipText": "Save these buying preferences for future use in other properties",
        "deleteConfirmTitle": "Remove template",
        "deleteConfirmText": "Are you sure you want to remove the buying interest template?",
        "delete": "Remove",
        "cancel": "Cancel"
      },
    },
    "housingCompanyHoldings": {
      "title": "Housing company holdings",
      "apartments_one": "Flat",
      "apartments_other": "Flats",
      "commercialSpaces_one": "Commercial space",
      "commercialSpaces_other": "Commercial spaces",
      "units": ""
    },
    "jaakko": {
      "sendFeedback": "Please send feedback to",
      "error": "Whoops. Something went wrong.",
      "title": "Jaakko's insights"
    },
    "housingCompanyInfo": {
      "title": "Housing company"
    },
    "map": {
      "title": "Map"
    },
    "comments": {
      "title": "General discussion",
      "emptyState": "<0>Here you can discuss the property publicly.</0><1>Start an anonymous discussion! 🥳</1>",
      "placeholder": "Share your thoughts about this property, add a photo or ask a question.",
      "send": "Send",
      "back": "Back",
      "pickPhoto": "Pick photo",
      "takePhoto": "Take photo",
      "commenterOrderNumberFirst": "First."
    },
    "filesDropBox": {
      "title": "Upload articles of association, financial statement, maintenance needs assessment or other related documents."
    },
    "documentDropzone": {
      "clickToUpload": "<0>Select file</0> <2>or drag and drop</2>",
      "termsAgreement": "By uploading documents, you agree to comply with our <1>terms of service</1>, and acknowledge that you have read and accept Jaakkocom Oy's <3>privacy policy</3>.",
      "buttonText": "Analyze",
      "loading": {
        "title": "Analyzing documents...",
        "text": "This may take a few minutes..."
      }
    },
    "buildingInfoBox": {
      "title": "Housing company"
    },
    "financialsInfoBox": {
      "title": "Financials"
    },
    "renovationsInfoBox": {
      "title": "Renovations"
    },
    "maintenanceNeedsAssessmentPlaceHolderText": "Upload a maintenance needs assessment or PTS plan, to get an analysis",
    "articlesOfAssociationPlaceHolderText": "Upload an articles of association, to get an analysis",
    "financialStatementPlaceHolderText": "Upload a financial statement or budget, to get an analysis",
    "streetView": {
      "title": "Street view"
    }
  },
  "mainMenuPages": {
    "faq": {
      "title": "Frequently asked questions",
      "whatIsJaakko": {
        "title": "What is Jaakko.com?",
        "paragraphs": {
          "first": "Jaakko.com is a new service that connects buyers and sellers to each other easier than ever, without obligations. If you don't find an interesting property on the current services or consider selling without the complicated and time-consuming process, Jaakko.com offers a simple and efficient way for a new kind of property interaction",
          "second": "Users of Jaakko.com can also discuss, share information and photos, and ask questions about any building. Through discussions, you can learn more about different properties and get valuable insights from other users.",
        }
      },
      "sellingAndBuying": {
        "title": "Selling and buying through Jaakko.com",
        "howItWorks": {
          "title": "How it works",
          "bulletPoints": {
            "express": "Select a home from the map and express your interest in buying or selling with just one click. Other users will only see that someone from the building might be open to a conversation – nothing more. If you're open to selling, you can also add details and photos to your interest, giving buyers the best possible view of the home directly in their feed.",
            "connect": "When there's mutual interest, you'll be notified via email, and a direct chat will open within Jaakko.com.",
            "anonymous": "Everything is anonymous at first – your email address will only be shared if you choose to respond to the other party's message or initiate contact yourself.",
            "information": "You can start the conversation by sharing what interests you, such as \"Could sell a 2-room apartment\" or \"Looking for a family apartment in the building\".",
            "removeinterest": "You can remove your interest at any time with one click, and you will no longer receive new contact requests.",
            "removechat": "You can delete any conversation at any time, after which you will no longer receive messages from that party."
          },
        },
        "safety": {
          "title": "Please keep safety and good manners in mind:",
          "bulletPoints": {
            "first": "Jaakko.com is designed for connecting people – the service does not participate in actual transactions or verify the identity of the parties involved.",
            "second": "Always verify the other party's identity before making any decisions or payments. This can be done by meeting in person or requesting official documents.",
            "third": "If needed, consult experts such as real estate agents or lawyers to ensure a safe transaction.",
            "fourth": "Messages must not contain offensive, illegal, harassing, or false statements, nor any content that violates laws or good practices.",
            "fifth": "Jaakko.com reserves the right to remove conversations and users who violate the service rules or good manners.",
            "sixth": "By following these guidelines, you help ensure that using the service is safe and enjoyable for everyone."
          }
        },
      },
      "benefits": {
        "title": "What benefits does a Jaakko.com account offer?",
        "paragraphs": {
          "first": "You can browse buildings without a Jaakko.com account, but with a Jaakko.com account you get additional features:",
          "second": "Creating a Jaakko.com account is free and takes only a minute!"
        },
        "bulletPoints": {
          "first": "Express your interest in selling or buying in any building.",
          "second": "Participate in discussions and share experiences.",
          "third": "Follow interesting properties and receive notifications of new information.",
          "fourth": "Share interesting properties.",
          "fifth": "Like interesting properties."
        }
      },
      "howToParticipate": {
        "title": "How do I participate in discussions?",
        "paragraph": "Discussing and sharing photos in the service is anonymous, but requires a Jaakko.com account. Discussions should follow good practices, and not mention your own or other people's names or contact information. Also, discussions should not contain offensive, illegal, disruptive, or false content, or any content that violates laws or good practices."
      },
      "typesOfRealEstate": {
        "title": "What types of properties does Jaakko cover?",
        "paragraph": "The map-based interface allows for exploring buildings, discussions, and the expression of interest in buying and selling anywhere in the world. If a property doesn't have a precise address (such as island cottages, etc.), it may still be partially missing from the service."
      },
      "payments": {
        "title": "Payments",
        "paragraph": "The basic functions of the service are free of charge, but in the future charges may be made for additional services. The free use of the service does not obligate to future payments."
      },
      "feedback": {
        "title": "How can I give feedback?",
        "paragraph": "All feedback is welcome. You can send feedback to support@jaakko.com. We are constantly developing the service and value your feedback."
      }
    },
    "contactUs": {
      "title": "Contact us",
      "customerSupport": "Customer support:",
      "businessId": "Business ID:",
      "country": "Finland"
    }
  },
  "signupLoginModal": {
    "backAria": "Back",
    "closeAria": "Close",
    "loginOrSignup": "Login or sign up",
    "continueWithGoogle": "Continue with Google",
    "continueWithFacebook": "Continue with Facebook",
    "orContinueWithEmail": "or continue with email",
    "loginOrSignupButton": "Continue",
    "login": "Login",
    "passwordPlaceholder": "Password",
    "loginButton": "Continue",
    "logout": "Logout",
    "logoutButton": "Logout",
    "emailPlaceholder": "Email",
    "infoBox": {
      "title": "Start for free – <tail>already <count/> listings!</tail>",
      "bulletPoints": {
        "freeAccount": "Create your account in seconds – no commitments.",
        "noFees": "Zero commissions or intermediaries – save thousands.",
        "anywhere": "Express buying interest in any home."
      },
      "testimonial": {
        "quote": "Our home had been on the market for over a year through various brokers without success. Through Jaakko, the right buyer was found quickly.",
        "author": "Sarita, Helsinki",
        "saving": "€15,000 saved on commission fees"
      }
    },
    "registerText": {
      "first": "By signing up, you create a Jaakko account and agree to follow our ",
      "second": "terms of service",
      "third": ", and acknowledge that you have read and accept Jaakkocom Oy's ",
      "fourth": "privacy policy."
    },
    "passwordRequirements": {
      "length": "Password must be at least 8 characters long.",
      "uppercase": "Password must contain at least one uppercase letter.",
      "lowercase": "Password must contain at least one lowercase letter.",
      "number": "Password must contain at least one number."
    },
    "checkPassword": "Check password.",
    "unexpectedError": "Oops! Something went wrong.",
    "signup": {
      "title": "Sign up",
      "accountExists": "It looks like you already have an account. Please login.",
      "signupButton": "Continue",
      "marketingConsent": "I'd like to receive emails from Jaakko about news and opportunities"
    },
    "emailVerification": {
      "title": "Verify your email address",
      "firstParagraph": "Enter the verification code",
      "secondParagraph": "Enter the verification code, which was sent to {{email}} (if you do not see the email, check your spam folder)",
      "codePlaceholder": "Verification code",
      "resendCode": "Resend code",
      "resendSuccess": "A new code has been sent to your email.",
      "smsVerifyLink": "Didn't receive it? Verify with SMS instead.",
      "smsTitle": "Verify with SMS",
      "smsSubtitle": "Enter the code sent to {{phone}}",
      "phonePlaceholder": "+358 40 123 4567",
      "sendSmsButton": "Send code via SMS",
      "smsSentSuccess": "Code sent to {{phone}}",
      "smsError": "Failed to send SMS. Please try again.",
      "invalidPhone": "Please enter a valid Finnish phone number.",
      "submitButton": "Verify",
      "rateLimitError": "Too many attempts. Please wait a moment and try again.",
      "tooManyAttempts": "Too many wrong codes. Request a new code by email.",
      "sessionRequired": "Use the SMS option in the browser you signed up in, or resend the code by email."
    },
    "forgotPassword": {
      "linkText": "Forgot password?",
      "title": "Reset password",
      "subtitle": "Enter your email address and we'll send you a link to reset your password.",
      "submitMessage": "If an account with that email exists, a password reset link has been sent.",
      "sendLinkButton": "Send Reset Link",
      "backToLogin": "Back to Login"
    },
    "errors": {
      "existsWithAnotherAuthenticationMethod": "This email is registered with another authentication method. Please sign in with your previously used method.",
      "existsWithGoogle": "This email is registered with Google. Please sign in with Google.",
      "existsWithFacebook": "This email is registered with Facebook. Please sign in with Facebook.",
      "existsWithEmailPassword": "This email is registered with email and password. Please sign in with your password.",
      "genericOAuth": "Authentication failed. Please try again.",
      "networkError": "Network error. Please check your connection and try again.",
      "emailCheckFailed": "Could not verify email. Please try again.",
      "genericSignupError": "Signup failed. Please try again."
    },
    "resetPasswordPage": {
      "title": "Set a new password",
      "newPasswordPlaceholder": "New password",
      "confirmPasswordPlaceholder": "Confirm new password",
      "submitButton": "Set New Password",
      "passwordMismatch": "Passwords do not match.",
      "successMessage": "Your password has been reset successfully. You can now log in with your new password.",
      "invalidLink": "Invalid or expired password reset link.",
      "tokenMissing": "Password reset token is missing.",
      "goToLogin": "Go to app"
    }
  },
  "metaTags": {
    "title": "Jaakko.com | Property Map & Silent Sale",
    "description": "Are you looking to sell your property or buy a new one? Whether you're listing your property for a silent sale or searching for your dream home, it's now easier than ever.",
    "ogTitle": "Jaakko.com | Property Map & Silent Sale",
    "ogDescription": "Are you looking to sell your property or buy a new one? Whether you're listing your property for a silent sale or searching for your dream home, it's now easier than ever.",
    "building": {
      "title": "Property {{address}} - Jaakko.com",
      "description": "Explore {{address}}. Share your interest in selling or buying, or participate in discussions.",
      "ogTitle": "Explore interesting property on Jaakko.com",
      "ogDescription": "Explore {{address}}. Share your interest in selling or buying, or participate in discussions."
    }
  },
  "shareButton": {
    "title": "Explore interesting property on Jaakko.com",
    "text": "Explore {{address}}. Share your interest in selling or buying, or participate in discussions.",
    "linkCopied": "Link copied to clipboard.",
    "linkCopiedError": "Link copy failed. Please copy the link manually.",
    "notShareable": "Not shareable"
  },
  "sharePrompt": {
    "sell": {
      "title": "Great! You're willing to sell",
      "description": "Your selling interest has been registered. Share it to find buyers faster!",
      "matchTitle": "Great! Buyers are also interested",
      "matchDescription": "You can now chat privately. Share your listing to find more buyers!"
    },
    "buy": {
      "title": "Great! You're interested in buying",
      "description": "Your buying interest has been registered. Share it to connect with sellers!",
      "matchTitle": "Great! Sellers are also interested",
      "matchDescription": "You can now chat privately. Share your listing to find more sellers!"
    },
    "benefit": {
      "findMatchesSeller": "More visibility",
      "findMatchesBuyer": "Discover hidden homes",
      "reachMoreBuyer": "More potential sellers",
      "reachMoreSeller": "More potential buyers",
      "faster": "Faster path to a deal"
    },
    "shareButton": "Share Now",
    "skipButton": "Maybe Later",
    "boostButton": "Boost with ads – 49,90 €",
    "boostSubtitle": "Get more buyers with targeted ads."
  },
  "boostModal": {
    "sellTitle": "Boost your listing’s visibility – €49.90",
    "buyTitle": "Boost your buying interest’s visibility – €49.90",
    "description": {
      "sell": "We’ll promote your home for 14 days on top social media channels. Reach even more potential buyers in the area.",
      "buy": "We’ll promote your buying interest for 14 days on top social media channels. The goal is to activate more sellers and bring new homes to the market."
    },
    "emailInfo": "Click below to receive a payment link and more details by email.",
    "cancelButton": "No thanks",
    "confirmButton": "Tell me more",
    "noCommitment": "This doesn’t bind you to anything yet.",
    "error": "Could not send the request. Please try again.",
    "or": "or"
  },
  "messages": {
    "loadTemplate": "Deed of sale template",
    "templateModal": {
      "title": "Deed of Sale Template",
      "subtitle": "Download a professional template to help finalize your property transaction",
      "description": "This template is designed for private property sales in Finland. It includes all essential fields for a legally sound transaction.",
      "features": {
        "title": "What's included:",
        "parties": "Buyer & seller details",
        "property": "Property information",
        "terms": "Payment terms & conditions",
        "signatures": "Signature fields"
      },
      "downloadButton": "Download Template",
      "downloadingButton": "Preparing...",
      "disclaimer": "The template is general in nature and intended for property shares in Finland. Jaakko.com is not responsible for its applicability to any individual transaction.",
      "fileInfo": "Word document • Finnish legal format"
    },
    "error": {
      "TOO_MANY_ATTACHMENTS": "Too many attachments. Maximum is 10",
      "unsupportedFile": "File type not supported."
    },
    "title": "Direct messages",
    "empty": "Express buying or selling interest. When the other party is found for the same property, a private conversation will open here.",
    "send": "Send",
    "tabs": {
      "inbox": "Inbox",
      "all": "All",
      "support": "Support"
    },
    "draft": {
      "hint": "Write a message to the seller. They will only be notified once you send it.",
      "placeholder": "Write a message…",
      "send": "Send"
    },
    "firstMessage": "Start of your conversation.",
    "welcomeTitle": "Your conversation starts here",
    "welcomeText": "Here you can discuss details about the home and arrange a viewing. Your email address will only be visible to the other party once you send them a message.",
    "welcomeTips": "Tips for discussion:",
    "tipPolite": "Be polite and respectful",
    "tipCaution": "Do not share sensitive information until you are sure about the other person",
    "tipDetails": "You can end the conversation at any time",
    "writePlaceholder": "Write a message... (Ctrl+Enter to send)",
    "writePlaceholderMobile": "Write a message...",
    "chatEndedPlaceholder": "This conversation has ended",
    "chatEndedMessage": "This conversation has been ended. No new messages can be sent.",
    "readStatus": { "sent": "Sent", "seen": "Seen" },
    "draftNotSentYet": "You are logged in. Press Send to send your message.",
    "tooLong_one": "Your message is longer than {{max}} characters. Remove {{count}} character to send.",
    "tooLong_other": "Your message is longer than {{max}} characters. Remove {{count}} characters to send.",
    "ownListing": "This is your own listing. You cannot message yourself.",
    "chatEnded": "Chat ended",
    "endChat": "End chat",
    "endChatConfirmTitle": "End chat",
    "endChatConfirmText": "Are you sure you want to end this conversation? Once ended, neither you nor the other person will be able to send messages in this chat again.",
    "confirm": "End chat",
    "cancel": "Cancel",
    "ending": "Ending",
    "today": "Today",
    "yesterday": "Yesterday",
    "anonymousUser": "Anonymous user",
    "buyer": "Interested buyer",
    "seller": "Interested seller",
    "buyerParticipant": "Buyer's invitee",
    "sellerParticipant": "Seller's invitee",
    "pendingInvitee": "a pending contact",
    "someone": "Someone",

    "you": "You",
    "preview": {
      "image_one": "{{count}} image",
      "image_other": "{{count}} images",
      "video_one": "{{count}} video",
      "video_other": "{{count}} videos",
      "pdf_one": "{{count}} document",
      "pdf_other": "{{count}} documents",
      "attachment_one": "{{count}} attachment",
      "attachment_other": "{{count}} attachments"
    },
    "listingRemoved": {
      "title": "Listing no longer available",
      "description": "The seller has removed this listing. You can still continue your conversation."
    },
    "buyInterestRemoved": {
      "title": "Buy interest no longer available",
      "description": "The buyer has removed their buy interest. You can still continue your conversation."
    },
    "participants": {
      "title": "Participants",
      "addPeople": "Add people",
      "member": "Member",
      "you": "(you)",
      "addedBy": "Added by {{name}}",
      "pendingInvite": "Pending invite",
      "cancelInvite": "Cancel invite",
      "leaveConversation": "Leave conversation",
      "leaveConfirmTitle": "Leave conversation?",
      "leaveConfirmText": "You will no longer be able to send or receive messages in this conversation.",
      "leaveConfirmButton": "Leave",
      "removeParticipant": "Remove from chat",
      "maxParticipants": "Maximum 4 participants reached",
      "participant": "Participant"
    },
    "invite": {
      "title": "Add people",
      "description": "Are you buying or selling with someone else? Invite them to join the conversation.",
      "emailLabel": "Email address",
      "emailPlaceholder": "Enter email address",
      "replaceWarning": "This will revoke the pending invitation to {{email}}",
      "sendInvite": "Send invite",
      "sending": "Sending...",
      "successExisting": "{{email}} has been added to the conversation",
      "successInvite": "Invitation sent to {{email}}",
      "successResent": "Invitation re-sent to {{email}}",
      "errorAlreadyParticipant": "This person is already in the conversation",
      "errorAlreadyInvited": "An invitation has already been sent to this email",
      "errorAlreadyAddedParticipant": "You have already added a participant. Each buyer or seller can invite only one person.",
      "errorConversationEnded": "This conversation has ended and no more participants can be added",
      "errorNotOriginalParticipant": "Only the original buyer or seller can invite participants",
      "errorEmailRequired": "Please enter an email address",
      "errorEmailInvalid": "Please enter a valid email address",
      "errorJaakkoConversation": "Participants cannot be added to a Jaakko conversation",
      "errorFailed": "Failed to send invite"
    },
    "system": {
      "participantAdded": "{{actor}} added {{target}} to the conversation",
      "participantRemoved": "{{actor}} removed {{target}} from the conversation",
      "participantLeft": "{{actor}} left the conversation",
      "youAddedParticipant": "You added {{target}} to the conversation",
      "youRemovedParticipant": "You removed {{target}} from the conversation",
      "youWereAdded": "{{actor}} added you to the conversation",
      "youWereRemoved": "{{actor}} removed you from the conversation",
      "inviteSent": "{{actor}} invited a user to the conversation",
      "youInvited": "You invited a user to the conversation",
      "youWereInvited": "{{actor}} invited you to the conversation",
      "participantJoined": "User joined the conversation",
      "youJoined": "You joined the conversation",
      "previewParticipantAdded": "A new participant joined",
      "previewParticipantLeft": "A participant left",
      "previewParticipantRemoved": "A participant was removed",
      "previewInviteSent": "A new participant was invited",
      "previewYouJoined": "You joined the conversation",
      "previewYouLeft": "You left the conversation",
      "previewYouWereRemoved": "You were removed from the conversation",
      "previewYouInvited": "You invited a new participant"
    },
    "options": "Options",
    "helpWithSelling": "Help with selling",
    "helpWithBuying": "Help with buying",
    "helpWithDeal": "Help with the deal",
    "selfSellingGuide": "Self-selling guide",
    "selfSellingGuideUrl": "https://info.jaakko.com/en-gb/how-to-sell-your-apartment-yourself",
    "getPersonalHelp": "Get expert help",
    "expertHelp": {
      "title": "Get expert help with documents and completing the sale.",
      "pricingBody": "Found a buyer or seller? Need help completing the sale?\n\nOur expert partner will complete the housing-share or real estate transaction on your behalf. No brokerage agreement. No commission.\n\nPrice: 990 €",
      "subtitle": "What do you need help with?",
      "topicDocuments": "Housing company documents",
      "topicAgreement": "Finalizing the deal",
      "topicNegotiation": "Negotiation",
      "topicPricing": "Pricing",
      "topicViewing": "Viewing arrangements",
      "topicOther": "Something else",
      "descriptionLabel": "What do you need help with?",
      "descriptionPlaceholder": "Briefly describe your situation or question",
      "contactLabel": "How would you like us to contact you?",
      "callMe": "Call me",
      "emailMe": "Email me",
      "phoneLabel": "Phone number",
      "emailLabel": "Email",
      "freeDisclaimer": "The conversation is free of charge and non-binding.",
      "continue": "Continue",
      "sendRequest": "Send request",
      "successTitle": "Request sent",
      "successMessage": "We'll review your situation and contact you by phone or email.",
      "responseTime": "Typical response time: within 1 business day",
      "backToChat": "Back to chat",
      "systemMessage": "Expert help requested. 🎉 <br/> We'll contact you by phone or email. You can continue your conversation normally.<br/>The other party will not see this message.",
      "limitTitle": "Request limit reached",
      "limitMessage": "You have reached the maximum number of open help requests. We'll process your existing requests first."
    },
    "firstMessageSuggestions": {
      "header": "Suggested first messages",
      "subheader": "Tap one to edit and send",
      "buyer": {
        "opener": {
          "withAddress": "Hi! This home caught my eye. Could you tell me a bit more about the apartment?",
          "generic": "Hi! This home caught my eye. Could you tell me a bit more about the apartment?",
        },
        "viewing": {
          "withAddress": "Hi! I\u2019m interested in {{address}}. Would you be open to arranging a viewing?",
          "generic": "Hi! I\u2019m interested in this home. Would you be open to arranging a viewing?",
        },
        "financials": {
          "withAddress": "Hi! I\u2019m interested in the home in {{address}}. Could you share a bit more about the housing company financials?",
          "generic": "Hi! I\u2019m interested in this home. Could you share a bit more about the housing company financials?",
        },
      },
      "seller": {
        "tellMore": {
          "withAddress": "Hi! Thanks for your interest in our home in {{address}}. I\u2019d be happy to tell you more about the place.",
          "generic": "Hi! Thanks for your interest in our home. I\u2019d be happy to tell you more about the place.",
        },
        "viewing": {
          "withAddress": "Hi! Thanks for your interest in our home {{address}}. Would you like to come for a viewing?",
          "generic": "Hi! Thanks for your interest in our home. Would you like to come for a viewing?",
        },
        "askMore": {
          "withAddress": "Hi! Thanks for your interest in our home {{address}}. Is there something specific you\u2019d like to know about the home or housing company?",
          "generic": "Hi! Thanks for your interest in our home. Is there something specific you\u2019d like to know about the home or housing company?",
        },
      },
      "aiButton": "Generate with AI",
      "aiGenerating": "Generating\u2026",
      "aiFailed": "Failed \u2014 try again",
    }
  },
  "exploreListings": {
    "allResults": "All results",
    "exploreButton": "Search listings",
    "title": "Off-Market Opportunities",
    "titleDesktop": "Discover Off-Market Opportunities",
    "searchPlaceholder": "Search by location",
    "filters": "Filters",
    "listingType": "Listing Type",
    "both": "All",
    "forSale": "Could sell",
    "buyingInterests": "Buying Interests",
    "buyingInterest": "Could buy",
    "propertySize": "Property Size",
    "minSize": "Min",
    "maxSize": "Max",
    "rooms": "Rooms",
    "any": "Any",
    "floor": "Floor",
    "minFloor": "Min",
    "maxFloor": "Max",
    "renovationStatus": "Renovation Status",
    "anyCondition": "Any condition",
    "recentlyRenovated": "Recently renovated",
    "goodCondition": "Good condition",
    "needsRenovation": "Needs renovation",
    "amenities": "Amenities",
    "hasElevator": "Elevator",
    "hasBalcony": "Balcony/Terrace",
    "includeIncompleteDetails": "Include listings with missing details",
    "includeIncompleteDetailsHelp": "Show possible matches when selected details are missing or unconfirmed.",
    "unconfirmedCount": "{{count}} listings with unconfirmed details",
    "unconfirmedTitle": "Listings with unconfirmed details",
    "unconfirmedDescription": "These may match, but some selected details cannot be confirmed.",
    "noConfirmedMatches": "No confirmed matches",
    "noConfirmedMatchesDescription": "These listings may still suit your search.",
    "unconfirmedField": {
      "seller": {
        "size": "Size not provided",
        "price": "Price unconfirmed",
        "rooms": "Room count not provided",
        "floor": "Floor not provided",
        "renovationStatus": "Condition not provided",
        "hasElevator": "Elevator unconfirmed",
        "hasBalcony": "Balcony or terrace unconfirmed"
      },
      "buyer": {
        "size": "Size preference unconfirmed",
        "rooms": "Room preference unconfirmed",
        "floor": "Floor preference unconfirmed",
        "renovationStatus": "Condition preference unconfirmed",
        "hasElevator": "Elevator preference unconfirmed",
        "hasBalcony": "Balcony or terrace preference unconfirmed"
      }
    },
    "clearAll": "Clear all",
    "cancel": "Cancel",
    "showResults": "Show results",
    "resultsFound": "results found with filters",
    "noResultsTitle": "No results found",
    "noResultsTitleSecondary": "No results found with filters",
    "noResultsDescription": "Try adjusting your filters or search in a different location.",
    "endOfResults": "You've reached the end of the results",
    "loading": "Loading...",
    "mapLoadError": "Error loading map services",
    "mapLoading": "Loading map services...",
    "today": "Today",
    "yesterday": "Yesterday",
    "daysAgo": "{{days}} days ago",
    "roomsShort": "rooms",
    "floorShort": "Floor",
    "elevator": "Elevator",
    "balcony": "Balcony",
    "contactSeller": "Contact Seller",
    "contactBuyer": "Contact Buyer",
    "viewOnMap": "View on Map",
    "interestedInBuying": "Hi! I'm interested in buying in this building.",
    "interestedInSelling": "Hi! I'm interested in your selling interest.",
    "openBuildingPage": "Open building page",
    "mightAlsoContain": "These {{secondaryResultsCount}} listings might also include what you are looking for:"
  },
  "recommendedProperties": {
    "title": "Recommended properties"
  },
  "listingCard": {
    "new": "New",
    "yourListing": "Your listing",
    "yourInterest": "Your interest",
    "messageSeller": "Ask seller",
    "couldBuy": "Ask seller",
    "couldSell": "Could sell",
    "openChat": "Open chat",
    "rooms": "rooms",
    "floor": "Floor",
    "balconyTerrace": "Balcony / terrace",
    "recentlyRenovated": "Recently renovated",
    "goodCondition": "Good condition",
    "needsRenovation": "Needs renovation",
    "like": "Add to favorites",
    "share": "Share",
    "goToPhoto": "Go to photo {{index}}",
    "prevPhoto": "Previous photo",
    "nextPhoto": "Next photo",
    "viewAllPhotos": "View all photos",
    "connectForDetails": "Interested seller – ask for more details",
    "connectBuyerForDetails": "A buyer is looking – suggest your home.",
    "ownSellerAddDetails": "Add details – attract more buyers.",
    "ownBuyerAddDetails": "Add details – attract more sellers.",
    "noSetPrice": "No set price",
    "estimatingPrice": "Estimating price…",
    "estimateInfoAria": "About this Jaakko estimate",
    "estimatingInfo": "Jaakko is estimating the price using AI and public market data. The estimate will be a guide, not an appraisal.",
    "estimateInfo": "Jaakko has estimated this price using AI and market data. This is not the seller’s asking price or an official valuation report, but an indicative conversation starter – you can negotiate the price directly with the seller."
  },
  "listingView": {
    "viewBuilding": "View building page",
    "viewOnMap": "View on map",
    "notFound": "Listing not found",
    "otherListings": "Other listings in this building",
    "sellersHere": "Sellers here",
    "buyersHere": "Buyers here",
    "otherSellersHere": "Other sellers here",
    "otherBuyersHere": "Other buyers here",
    "explore": "Explore Jaakko",
    "interestedPrompt": "Interested? Send a message to the seller.",
    "openChatPrompt": "You already have a chat with the seller.",
    "buyerPrompt": "Do you own a home this buyer is looking for? Let them know.",
    "sellerBadge": "Seller",
    "buyerBadge": "Buyer"
  },
  "priceEstimation": {
    "title": "Property price estimation report",
    "notAvailable": "Not available",
    "estimatedValue": "Estimated Market Value",
    "priceRange": "Price Range",
    "pricePerSqm": "Price per m²",
    "confidence": "Confidence",
    "propertyDetails": "Property details",
    "size": "Size",
    "rooms": "Rooms",
    "floor": "Floor",
    "elevator": "Elevator",
    "balcony": "Balcony",
    "condition": "Condition",
    "buildingType": "Building type",
    "fullAnalysis": "Full Market Analysis",
    "marketFactors": "Key Market Factors",
    "comparableProperties": "Comparable Properties",
    "recommendations": "Value Optimization Recommendations",
    "sources": "Data Sources",
    "disclaimer": "This estimation is based on AI analysis of current market data and should be used as a guideline only. Actual market value may vary.",
    "generatedOn": "Generated on",
    "print": "Print",
    "share": "Share",
    "close": "Close",
    "shareTitle": "Property Price Estimation",
    "shareText": "Check out this property price estimation for",
    "linkCopied": "Link copied to clipboard",
    "or": "or",
    "exploreJaakko": "Explore Jaakko"
  },
  "priceEstimations": {
    "pageTitle": "My Price Estimations",
    "loading": "Loading estimations...",
    "allStatuses": "All statuses",
    "statusQueued": "Queued",
    "statusInProgress": "In Progress",
    "statusCompleted": "Completed",
    "statusFailed": "Failed",
    "statusTimedOut": "Timed out",
    "noEstimations": "No price estimations yet",
    "noEstimationsDesc": "Your price estimations will appear here once you request them.",
    "unknownAddress": "Unknown address",
    "created": "Created",
    "completed": "Completed",
    "viewReport": "View Report",
    "errorLoadingReport": "Failed to load report. Please try again.",
    "failedMessage": "Estimation failed. Please try again.",
    "timedOutMessage": "Estimation timed out. Please try again.",
    "pageInfo": "Page",
    "loadMore": "Load more",
    "rooms": "rooms",
    "confidence": "confidence"
  },
  "feedback": {
    "title": "Send Feedback",
    "intro": "We'd love to hear from you! Your feedback helps us improve Jaakko.com.",
    "type": {
      "label": "Feedback Type",
      "general": "General Feedback",
      "bug": "Bug Report",
      "feature": "Feature Request",
      "improvement": "Improvement Suggestion"
    },
    "email": {
      "label": "Your Email",
      "placeholder": "your.email@example.com",
      "help": "We'll use this to respond to your feedback."
    },
    "subject": {
      "label": "Subject",
      "placeholder": "Subject"
    },
    "message": {
      "label": "Your Feedback",
      "placeholder": "Please share your thoughts, suggestions, or report any issues you've encountered..."
    },
    "submit": "Send Feedback",
    "submitting": "Sending...",
    "success": "Thank you for your feedback! We'll get back to you soon via email.",
    "validation": {
      "messageRequired": "Please enter your feedback message.",
      "emailRequired": "Please enter your email address.",
      "emailInvalid": "Please enter a valid email address."
    },
    "error": {
      "submitFailed": "Failed to send feedback. Please try again."
    }
  },
  "tipBuyer": {
    "button": "Suggest",
    "menuTitle": "Suggest your home to the buyer",
    "emptyState": "You don't have any properties for sale yet",
    "confirmTitle": "Tip this buyer about your property?",
    "confirmDescription": "The buyer will receive a message from Jaakko about your property.",
    "messagePreview": "A seller tipped you about this property:",
    "receivedMessage": "Based on your buying interest a seller tipped you about their property:",
    "sendTip": "Send tip",
    "success": "Tip sent successfully!",
    "successTitle": "Tip sent!",
    "successSubtitle": "The buyer will be notified about your property",
    "alreadyTipped": "You have already tipped this buyer about this listing",
    "sent": "Sent",
    "dailyLimitReached": "You've used your daily tip. Try again tomorrow!",
    "conversationPreview": "🏠 A seller tipped you about a property",
    "loginPrompt": "Login to suggest your home to the buyer"
  },
  "profile": {
    "title": "Profile",
    "sellListings": "My places",
    "buyInterests": "My buy interests",
    "priceEstimations": "Price estimations",
    "accountSettings": "Account settings",
    "logOut": "Log out",
    "phoneNumber": "Phone number",
    "edit": "Edit",
    "add": "Add",
    "cancel": "Cancel",
    "save": "Save",
    "addPhoneNumber": "Add your phone number to receive SMS notifications, when a buyer or seller expresses interest in your listing, a user sends you a private message, or your price estimation is ready. \nNote: We do not give your number to other users and SMS messages are free for you.",
    "phonePlaceholder": "40 123 4567",
    "sendCode": "Send verification code",
    "verifyCode": "Enter the verification code",
    "verifyCodePlaceholder": "6-digit code",
    "verify": "Verify",
    "resendCode": "Resend code",
    "codeSent": "Verification code sent to {{phone}}",
    "codeResent": "New code sent",
    "phoneVerified": "Phone number verified",
    "removeNumber": "Remove number",
    "removeNumberConfirm": "Are you sure you want to remove your phone number? SMS notifications will be disabled.",
    "smsNotifications": "SMS notifications",
    "smsNotificationsDescription": "You will receive an SMS notification when a buyer or seller expresses interest in your listing, you receive a new private message, or your price estimation is ready.",
    "invalidPhone": "Please enter a valid Finnish phone number (e.g. +358401234567).",
    "phoneAlreadyInUse": "This phone number is already in use by another account.",
    "rateLimitExceeded": "Too many attempts. Please try again later.",
    "smsSendFailed": "Failed to send SMS. Please try again later.",
    "invalidCode": "Invalid verification code.",
    "codeExpired": "Verification code expired. Please request a new one.",
    "genericError": "Something went wrong. Please try again.",
    "phoneAlreadyVerifiedHint": "This number is already verified. Change the number to send a new code.",
    "phoneAlreadyVerified": "This phone number is already verified.",
    "noSellListings": "No places yet.",
    "noBuyListings": "No buy interests yet.",
    "mySellListings": "My places",
    "myBuyInterests": "My buy interests",
    "notificationSettings": "Notification settings"
  },
  "notificationSettings": {
    "pageTitle": "Notification settings",
    "tableDescription": "Choose which notifications you receive via SMS or email.",
    "smsColumn": "SMS",
    "emailColumn": "Email",
    "match": "Match (buyer/seller found)",
    "message": "New message from another user",
    "priceEstimation": "Price estimation ready",
    "propertyTip": "Property tip",
    "marketingConsent": "Marketing messages",
    "marketingSection": "Marketing",
    "saved": "Settings saved",
    "errorSaving": "Failed to save settings. Please try again.",
    "phoneRequiredHint": "Add and verify your phone number to enable SMS notifications."
  },
  "marketingConsentModal": {
    "headerTitle": "Stay in the loop",
    "headline": "I want tips and updates from Jaakko",
    "benefits": {
      "first": "New homes, price insights and Jaakko updates",
      "second": "Tips for buying and selling without a broker",
      "third": "Occasional offers, no spam"
    },
    "decline": "Not now",
    "accept": "Send updates",
    "subtext": "You can unsubscribe at any time."
  },
  "verification": {
    "verifiedPerson": "Verified person",
    "verifiedSeller": "Verified seller",
    "verifiedBuyer": "Verified buyer",
    "verifyIdentity": "Verify identity",
    "inProgress": "Verification in progress",
    "incompleteTryAgain": "Verification incomplete. Try again."
  }
};
